import React from "react";
import  toWords  from "number-to-words";
 
 
const UnderTabelbox = ({
  productDiscountPercentage,
  productDiscount,
  subTotal,
  totalCgstAmount,
  totalSgstAmount,
  discountAmount,
  discount,
  totalAmount,
  cgstTax,
  sgstTax,
 
}) => {
  
  const convertToWords = (num) => {
    if (isNaN(num) || num === null) return "";
 
    const indianNumbering = (num) => {
        const units = ["", "Thousand", "Lakh", "Crore"];
        const strNum = num.toString();
        const length = strNum.length;
       
        if (length <= 3) return toWords.toWords(num);
        let result = "";
 
        if (length > 3 && length <= 5) {
            result += toWords.toWords(parseInt(strNum.slice(0, length - 3))) + " Thousand ";
            if (parseInt(strNum.slice(-3)) > 0) {
                result += toWords.toWords(parseInt(strNum.slice(-3)));
            }
        } else if (length > 5 && length <= 7) {
            result += toWords.toWords(parseInt(strNum.slice(0, length - 5))) + " Lakh ";
            if (parseInt(strNum.slice(-5)) > 0) {
                result += indianNumbering(parseInt(strNum.slice(-5)));
            }
        } else if (length > 7) {
            result += toWords.toWords(parseInt(strNum.slice(0, length - 7))) + " Crore ";
            if (parseInt(strNum.slice(-7)) > 0) {
                result += indianNumbering(parseInt(strNum.slice(-7)));
            }
        }
 
        return result.trim();
    };
 
    let words = indianNumbering(num).replace(/,/g, "");
    return words.charAt(0).toUpperCase() + words.slice(1);
};
 
 
  const formatNumber = (value) => {
    let num = parseFloat(value);
    if (isNaN(num)) return "";
    return num.toLocaleString("en-IN");
  };
  return (
    <div className="pdfpadding" style={{ paddingRight: "0px" }}>
      <div
  style={{
    position: "absolute",
    bottom: "25px",
    right: "35px",
    width: "180px",
    height: "80px",
    padding: "1px",
    borderRadius: "5px",
    fontWeight: "medium",
    textAlign: "center",
    border: "1px solid black",
    fontSize: "9px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "2px",
    paddingTop: "2px",
    paddingRight: "3px"
  }}
>
  <div> For Keel Info Solution Private Limited</div>
  <div
    style={{
      textAlign: "right",
      fontSize: "9px",
      fontWeight: "medium",
      alignSelf: "flex-end",
    }}
  >
    Authorized Signatory
  </div>
</div>
      <div className="pdfundertabel">
        <div className="pdfundertabel-box1">
          <p>Total In Words</p>
          <h2>{convertToWords(Number(totalAmount))} Rupees Only</h2>
          <p style={{ fontSize: "13px", marginTop: "10px" }}>Notes</p>
      <p style={{ fontSize: "13px", margin: "0px 0px" }}>
        Looking Forward for your business.
      </p>
        </div>
        <div className="pdfundertabel-box2">
          <div style={{ width: "10%" }}></div>
          <div style={{ width: "90%", paddingRight: "10px" }}>
          <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p>Discount ({formatNumber(productDiscountPercentage)}%)</p>
              <p>{formatNumber(productDiscount)}</p>
            </div>
       
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p>Sub total</p>
              <p>{formatNumber(subTotal)}</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p>CGST ({formatNumber(cgstTax)}%)</p>
              <p>{formatNumber(totalCgstAmount)}</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <p>SGST ({formatNumber(sgstTax)}%)</p>
              <p>{formatNumber(totalSgstAmount)}</p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2>Total</h2>
              <h2>{formatNumber(totalAmount)}</h2>
            </div>
          </div>
        </div>
      </div>
     
    </div>
  );
};
 
export default UnderTabelbox;